import { OrganizationUserRole } from 'libs/end-to-end/src/types/users/organization-user-roles';
import { z } from 'zod';

export const OrganizationRoleAssignment = z.object({
  organizationId: z.string(),
  organizationRole: OrganizationUserRole,
});

export type OrganizationRoleAssignment = z.infer<
  typeof OrganizationRoleAssignment
>;

export const OrganizationRoleAssignments = z.union([
  z.literal('superAdmin'),
  OrganizationRoleAssignment.array(),
]);

export type OrganizationRoleAssignments = z.infer<
  typeof OrganizationRoleAssignments
>;
